import React, { useState } from "react";

const ToolIcon = ({ d }) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>;
const ICONS = {
  wrench: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
  scan: "M3 7V5a2 2 0 0 1 2-2h2 M17 3h2a2 2 0 0 1 2 2v2 M21 17v2a2 2 0 0 1-2 2h-2 M7 21H5a2 2 0 0 1-2-2v-2 M7 12h10",
  count: "M4 7V4h16v3 M9 20h6 M12 4v16",
  diff: "M12 3v18 M5 8l4 4-4 4 M19 8l-4 4 4 4",
};

export const TOOLS = [
  { id: "scanner", name: "ماسح العقود", icon: "scan" },
  { id: "counter", name: "عداد", icon: "count" },
  { id: "diff", name: "مقارن", icon: "diff" },
];

export default function ToolsLauncher({ onOpen }) {
  const [drop, setDrop] = useState(false);
  return (
    <div style={{ position: "relative", display: "inline-block" }} onMouseEnter={() => setDrop(true)} onMouseLeave={() => setDrop(false)}>
      <button className="pm-act mob-hide" onClick={() => setDrop(!drop)}>
        <ToolIcon d={ICONS.wrench} />
        <span className="pm-act-lbl">أدوات</span>
      </button>
      {drop && (
        <div className="fade-in" style={{ position: "absolute", top: "100%", insetInlineStart: 0, zIndex: 930, display: "flex", flexDirection: "row", gap: 4, paddingTop: 6, background: "transparent", whiteSpace: "nowrap" }}>
          {TOOLS.map((t) => (
            <button key={t.id} className="pm-act" onClick={() => { onOpen && onOpen(t.id); setDrop(false); }}>
              <ToolIcon d={ICONS[t.icon]} />
              <span className="pm-act-lbl">{t.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
